export const BONUS_DEAL_VALUE = '<VALUE> points';
